var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    zoomAndPan: "magnify",
    viewBox: "0 0 1024.5 1307.999939",
    height: 1744,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cc7ca99b49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 387.171875 L 482 387.171875 L 482 1165 L 0 1165 Z M 0 387.171875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6b5ffc1fe6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 529 387.171875 L 1024 387.171875 L 1024 1165 L 529 1165 Z M 529 387.171875 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc7ca99b49)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#318ba2",
    d: "M 264.980469 720.207031 C 216.546875 720.207031 171.972656 736.34375 135.949219 763.21875 C 139.492188 651.035156 226.222656 538.8125 397.351562 426.570312 L 371.957031 387.171875 C 123.996094 541.210938 0 710.265625 0 894.3125 C 0 978.832031 23 1045.0625 69.039062 1092.90625 C 115.046875 1140.84375 173.304688 1164.75 243.742188 1164.75 C 314.226562 1164.75 371.015625 1145.523438 414.238281 1107.003906 C 457.429688 1068.539062 479.058594 1022.003906 479.058594 967.566406 C 479.058594 966.953125 478.945312 966.503906 478.945312 965.847656 C 480.265625 956.191406 481.199219 946.4375 481.199219 936.351562 C 481.199219 817.011719 384.359375 720.207031 264.980469 720.207031 Z M 264.980469 720.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6b5ffc1fe6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#318ba2",
    d: "M 964.054688 1085.597656 C 966.847656 1082.363281 970.238281 1079.28125 972.808594 1075.902344 C 1004.65625 1038.234375 1024 989.613281 1024 936.363281 C 1024 817.023438 927.179688 720.1875 807.800781 720.1875 C 753.121094 720.1875 703.34375 740.644531 665.25 774.144531 C 665.25 772.8125 665.035156 771.6875 665.035156 770.316406 C 665.035156 655.757812 752.371094 541.136719 927.117188 426.550781 L 901.742188 387.171875 C 653.75 541.210938 529.757812 710.265625 529.757812 894.351562 C 529.757812 978.871094 552.753906 1045.09375 598.816406 1092.9375 C 644.8125 1140.875 703.058594 1164.8125 773.5 1164.8125 C 843.9375 1164.8125 900.800781 1145.554688 943.992188 1107.015625 C 950.105469 1101.640625 954.847656 1095.601562 960.082031 1089.835938 C 961.460938 1088.464844 962.703125 1087.03125 964.054688 1085.597656 Z M 964.054688 1085.597656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.844261d045ed5f50b73ee52acb20d10e.svg";
export { ForwardRef as ReactComponent };